export default __webpack_public_path__ + "static/media/Profane Opus.3dda84a9.jpg";